import React, { Component } from "react";
import { Button } from "react-bootstrap";

export default class BackButton extends Component {
    render() {
        return (
            <Button className="back-to-home" href={this.props.href}>{this.props.text}</Button>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/BackButton.jsx.erb